//////////////////////////////////////////////////////////////////////////////////////////   IMPORT
///////////////////////////////////////////////////////////   REACT
import React from 'react';
///////////////////////////////////////////////////////////   LIBS
import styled from 'styled-components';
import { _SETTINGS } from 'config/settings';
import { millToTimecode } from 'assets/js/video-methods';
///////////////////////////////////////////////////////////   SCSS
import './light-table-panel.styles.scss';
///////////////////////////////////////////////////////////   INTERFACE
export interface PostProps {
  mainVideo: any[];
  player: any[];
  vxRef: any[];
}
export interface FrameProps {
  index: number;
  thumbW: number;
  thumbH: number;
  imgUrl: string;
  style: any;
}

///////////////////////////////////////////////////////////   STYLED COMPONENTS
export const StyleFrame = styled.div<FrameProps>`
  width: ${(props) => (props.thumbW ? props.thumbW + 'px' : '160px')};
  height: ${(props) => (props.thumbH ? props.thumbH + 'px' : '90px')};
  background-image: url(${(props) => props.imgUrl});
`;

//////////////////////////////////////////////////////////////////////////////////////    CLASS SETUP
export default class LightTable extends React.Component<any, { [key: string]: any }> {
  constructor(props: any) {
    super(props);
    this.state = {
      isTcVisible: true, // TODO:: change TC visibility
      ...this.props,
      vx: this.props.vxRef
    };
  }
  ///////////////////////////////////////////////////////////   LIFECYCLE METHODS
  componentDidUpdate(prevProps: PostProps) {
    if (this.props !== prevProps) {
      this.setState({ ...this.props });
    }
    if (this.props.mainVideo !== prevProps.mainVideo) {
      this.setState({ ...this.props.mainVideo });
    }
    if (this.props.vxRef !== prevProps.vxRef) {
      this.setState({ vx: this.props.vxRef });
    }
  }
  /**
   * Jump to frame
   * @param t
   */
  private jumpToSnap = (t: number): void => {
    const { vx } = this.state;
    if (vx) {
      const vid = vx.current.vp.current.player;
      let wasPaused: boolean = vid.paused();
      vid.pause();
      vid.currentTime(t);
      wasPaused ? vid.pause() : vid.play();
    }
  };
  ///////////////////////////////////////////////////////////   CLASS METHODS
  /**
   * Render each frames
   * Generate individual frames from pre-rendered image sprite's grid.
   * @returns JSX.Element
   */
  private Frame = (): any => {
    const { program, preRenderedThumbWidth, preRenderedThumbHeight, preRenderedThumbUrl, preRenderedThumbInterval } = this.state;
    const totalSprites: number = _SETTINGS.sprite.rows * _SETTINGS.sprite.cols;
    let fixFrameLength = program.find((x: any) => {
      return x.id === 'duration' ? x : 0;
    })?.data;
    let interval = Math.ceil(fixFrameLength / totalSprites);
    let frNum = Math.ceil(fixFrameLength / interval);
    let totalFrameNum = frNum ? frNum : 0;
    // let diff = totalSprites - totalFrameNum;
    if (!program || !totalFrameNum) return <></>;
    let arr: number[] = new Array(totalFrameNum).fill(null).map((d: any, i: number) => ++i),
      col: number = 0,
      row: number = 0;
    return (
      <div className='lightTable'>
        {arr.map((_i: any, k: number) => {
          let t: number = k * preRenderedThumbInterval,
            colNum: number = k % _SETTINGS.sprite.cols ?? col++,
            rowNum: number = colNum === _SETTINGS.sprite.cols - 1 ? row++ : row;
          return (
            <div key={k} className={'lightTable__frameContainer'}>
              <StyleFrame index={k} imgUrl={preRenderedThumbUrl} thumbW={preRenderedThumbWidth} thumbH={preRenderedThumbHeight} className='lightTable__frame' onClick={() => this.jumpToSnap(t)} style={{ backgroundRepeat: 'no-repeat', backgroundPositionX: colNum * -preRenderedThumbWidth, backgroundPositionY: rowNum * -preRenderedThumbHeight }} />
              {this.state.isTcVisible && (
                <div className='lightTable__tc' style={{ width: preRenderedThumbWidth }}>
                  {millToTimecode(Math.floor(t))?.toString().slice(0, -3)}
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  ///////////////////////////////////////////////////////////   RENDER
  render() {
    return <this.Frame />;
  }
}
